// extracted by mini-css-extract-plugin
export default {"root":"kEM1ZmnfTX","item":"kU5arGNo1C","item_disabled":"fPY8i9Gzwy","title":"WqPhqBig7V","title_clickable":"F94n0MGTsj","counter":"HFqZGeKZzv"};